import React, { memo } from 'react'
import InfoBox from 'components/InfoBox/InfoBox'

const TitleSection = ({ title = '', errorMessage = '' }) => {
  return (
    <div className="title_section">
      <h3 className="title">{title}</h3>
      {!!errorMessage && <InfoBox message={errorMessage} />}
    </div>
  )
}

export default memo(TitleSection)
